interface ProgressBarProps {
    progress: number;
    tone?: "info" | "success" | "danger";
}

const TONE_CLASSES: Record<NonNullable<ProgressBarProps["tone"]>, string> = {
    info: "bg-brand-600",
    success: "bg-green-600",
    danger: "bg-red-600",
};

export default function ProgressBar({ progress, tone = "info" }: ProgressBarProps) {
    const clamped = Math.max(0, Math.min(100, progress));
    return (
        <div
            role="progressbar"
            aria-valuenow={clamped}
            aria-valuemin={0}
            aria-valuemax={100}
            className="h-2.5 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700"
        >
            <div
                className={`h-full rounded-full transition-all duration-500 ease-out ${TONE_CLASSES[tone]}`}
                style={{ width: `${clamped}%` }}
            />
        </div>
    );
}
